import Vue from 'vue';
import firebase, { database } from "@/plugins/firebase";
import { seasonCollection } from "@/store/seasonYear";
import { callFn } from "@/utils/functionsClient";
export const receiptsCollection = () => seasonCollection('receipts');
export const ReceiptModule = {
    namespaced: true,
    state: [],
    mutations: {
        store(state, receipt) {
            const index = state.findIndex(x => x.id === receipt.id);
            if (index === -1) {
                state.push(receipt);
                return;
            }
            Vue.set(state, index, receipt);
        },
        destroy(state, id) {
            const index = state.findIndex(x => x.id === id);
            if (index !== -1) {
                state.splice(index, 1);
            }
        },
        clear(state) {
            state.splice(0, state.length);
        },
    },
    actions: {
        async listen(context) {
            context.commit('clear');
            return database.collection(receiptsCollection()).onSnapshot(snapshot => {
                for (const change of snapshot.docChanges()) {
                    if (change.type === 'removed') {
                        context.commit('destroy', change.doc.id);
                    }
                    else {
                        context.commit('store', { id: change.doc.id, data: change.doc.data() });
                    }
                }
            });
        },
        async retryEet(context, receipt) {
            return callFn('retryEet', { receiptId: receipt.id });
        },
        /** Verification sale (overeni=true) - checks the certificate and the EET connection. */
        async pdfUrl(context, receipt) {
            if (!receipt.data.pdfPath) {
                throw new Error('PDF není k dispozici');
            }
            return firebase.storage().ref(receipt.data.pdfPath).getDownloadURL();
        },
    },
    getters: {
        all(state) {
            return state;
        },
        active(state) {
            return state.filter(receipt => !receipt.data.deletedAt);
        },
    },
};
